import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Col, Justify, Row } from 'tea-component';
import { useCreation, useMemoizedFn } from 'ahooks';
import { useIntl, useParams } from 'umi';
import moment from 'moment';
import SelectChoice from '@/pages/intelligence/components/SelectCompoenet/SelectChoice';
import MarketSummaryTop from '../components/MarketSummaryTop';
import MarketEchartsMap from '../components/MarketEchartsMap';
import MarketDetailsBottom from '../components/MarketDetailsBottom';
import { downloadMarSizeData } from '../hooks';
import {
  getMarketSizeDateList,
  getGlobalSizePlayersDatas,
  getGlobalSizeRevenueDatas,
} from '@intelligence/services/globalView';

// 获取去年时间
export const pastYear = moment().subtract(1, 'year').format('YYYY');
const curYear = moment().format('YYYY');
// 筛选器选择近几年份
export const LENGTH_YEAR = 2;
const ByRevenue = (props: { tab: string }) => {
  const { tab } = props;
  const [changeValue, setChangeValue] = useState('');
  const type = tab === 'revenue';
  const { formatMessage } = useIntl();
  const [btnLoading, setBtnLoading] = useState(false);
  // 年份列表
  const [optionsList, setOptionsList] = useState<{ text: string; value: string }[]>([]);

  const [cardLoading, setCardLoading] = useState(true);
  const [cardDatas, setCardDatas] = useState({});

  // 年份回调
  const handleOnChangeYear = useMemoizedFn((value: string) => {
    setChangeValue(value);
    getGlobalSizePlayerSummary(value);
  });

  const getGlobalSizePlayerSummary = async (year: string) => {
    let paramsTemp: any = {
      total_date: (+year).toString(),
      start_date: (+year - 2).toString(),
      end_date: (+year + 3).toString(),
    };

    if (tab == 'revenue') {
      paramsTemp = {
        ...paramsTemp,
        region_top: 6,
        genre_top: 6,
        genre_region_top: 6,
      };
    } else {
      paramsTemp = {
        ...paramsTemp,
        region_top: 6,
      };
    }

    // 如果时间为空，不发出请求，只返回空
    setCardLoading(true);
    try {
      const res = await (tab == 'revenue'
        ? getGlobalSizeRevenueDatas(paramsTemp)
        : getGlobalSizePlayersDatas(paramsTemp));
      const dateObj = res?.data;
      setCardDatas(dateObj);
    } catch (error) {
      setCardDatas({});
    } finally {
      setCardLoading(false);
    }
  };

  useEffect(() => {
    // 获取有数据的时间列表范围
    async function fetchTimeAndData() {
      try {
        const res = await getMarketSizeDateList({});
        const dateList = res?.data;
        if (Array.isArray(dateList) && dateList?.length) {
          // feat: 默认今年
          const year = dateList?.includes(curYear) ? curYear : dateList[dateList.length - 1];
          setChangeValue(year);
          const options = dateList.map((t) => ({ text: t, value: t }));
          setOptionsList(options);

          getGlobalSizePlayerSummary(year);
        }
      } catch (error) {
        setChangeValue('');
        setOptionsList([]);
      }
    }

    // 调用上面定义的函数
    fetchTimeAndData();
  }, [tab]);

  // 每个card的title展示
  const newzooTitle = useMemo(
    () =>
      ({
        revenue: {
          header: formatMessage({ id: 'dbi_global_view_golbal_market' }),
          topLeft: formatMessage({
            id: 'dbi_global_view_trends_market_platform',
          }),
          topCenter: formatMessage({
            id: 'dbi_global_view_trends_revenue_region',
          }),
          topRight: formatMessage({ id: 'dbi_global_view_region_genre' }),
          bottomRight: formatMessage({ id: 'dbi_global_view_year_details' }),
          bottomLeft: formatMessage({ id: 'dbi_global_view_year_map' }),
          tipMapText: formatMessage({ id: 'dbi_global_view_revenue_tip_text' }),
          tooltipTitleLeft: formatMessage({ id: 'dbi_global_view_year_revenue' }),
          tooltipTitleCenter: formatMessage({ id: 'dbi_global_view_year_revenue' }),
          tooltipTitleRight: formatMessage({ id: 'dbi_global_view_year_revenue' }),
        },
        players: {
          header: formatMessage({
            id: 'dbi_global_view_play_online_population',
          }),
          topLeft: formatMessage({ id: 'dbi_global_view_play_trends' }),
          topCenter: formatMessage({
            id: 'dbi_global_view_play_trends_payers',
          }),
          topRight: formatMessage({ id: 'dbi_global_view_play_region' }),
          bottomRight: formatMessage({ id: 'dbi_global_view_play_details' }),
          bottomLeft: formatMessage({ id: 'dbi_global_view_play_map' }),
          tipMapText: formatMessage({ id: 'dbi_global_view_player_tip_text' }),
          tooltipTitleLeft: formatMessage({ id: 'dbi_global_view_players' }),
          tooltipTitleCenter: formatMessage({ id: 'dbi_global_view_payers2' }),
          tooltipTitleRight: formatMessage({ id: 'dbi_global_view_play_region' }),
        },
      }[tab as string]),
    [tab, formatMessage],
  );
  const handleRevenueDownload = useMemoizedFn(async () => {
    if (btnLoading) return;
    setBtnLoading(true);
    try {
      const data = await downloadMarSizeData({
        // 下载和当前选择的时间是没有关系,下载最新的文件就可以
        file_name: `Newzoo-Global-Games-Market-Data.xlsx`, // 参数
        // file_name: `Newzoo-Global-Games-Market-Data-${
        //   Number(changeValue) + 1
        // }.xlsx`,
      });
      const aLink = document.createElement('a');
      const blob = new Blob([data]);
      aLink.download = `Global-Games-Market-Data.xlsx`; // 文件名
      // aLink.download = `Newzoo-Global-Games-Market-Data-${
      //   Number(+changeValue) + 1
      // }.xlsx`;
      aLink.href = URL.createObjectURL(blob);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    } catch (err) {
      console.log(err);
    }

    setBtnLoading(false);
  });
  return (
    <>
      <Justify
        left={
          <>
            <SelectChoice
              changeValue={changeValue}
              labelValue={formatMessage({ id: 'dbi_global_view_year' })}
              optionsList={optionsList}
              getSelectMultiple={handleOnChangeYear}
              listHeight={234}
            />
          </>
        }
        right={
          <>
            <Button
              icon="download"
              // title={formatMessage({ id: 'dbi_download_data' })}
              loading={btnLoading}
              className="ns-btn--icon trend-justify-btn"
              onClick={handleRevenueDownload}
              disabled={btnLoading || !changeValue}
            />
          </>
        }
      />
      <div className="dbi-global-view-maincontent">
        <MarketSummaryTop {...{ changeValue, type, newzooTitle, cardDatas, cardLoading }} />
        <div className="map-placeholder">
          <Row className="dbi-revenue-context">
            <Col span={12}>
              <MarketEchartsMap {...{ changeValue, type, newzooTitle }} />
            </Col>
            <Col span={12}>
              <MarketDetailsBottom {...{ changeValue, type, newzooTitle }} />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default ByRevenue;
